<template>
  <p-text-field-formatted
    v-bind="$attrs"
    :display-formatter="formatDisplay"
    :value-formatter="formatValue"
    v-on="$listeners"
  ></p-text-field-formatted>
</template>

<script lang="ts">
  import Vue from 'vue';
  import { CurrencyCodeType } from '../../plugins/localization/currencyCodes';

  export default Vue.extend({
    props: {
      currency: { default: undefined, type: String },
    },
    methods: {
      formatValue(value: any) {
        const isNaN = Number.isNaN(Number.parseFloat(value));
        if (isNaN) {
          return 0;
        }
        return value;
      },
      formatDisplay(value: any) {
        const isNaN = Number.isNaN(Number.parseFloat(value));
        if (isNaN) {
          return this.$format.currency(0, this.currency as CurrencyCodeType);
        }
        return this.$format.currency(value, this.currency as CurrencyCodeType);
      },
    },
  });
</script>
